import BrowseCategoryShared from "./browse-category/BrowseCategoryPage";
import {
	fetchSearchList,
} from "../data/api/search";
import { dasherize } from '../utils/dom';
import { trackError } from '../utils/error-tracking';
import { asError } from '../hooks/as-error';

export async function getServerSideProps(context) {
	const {
		params: { category },
	} = context;

	// The shared server singleton, imported lazily *inside* this server-only
	// function: a top-level import of the Prisma client leaks @prisma/client into
	// this page's client bundle. A module-scope `new PrismaClient()` used to sit
	// here, and every extra client is an extra connection pool of its own beside
	// `lib/prisma`'s — the pool is the thing that runs out. Do NOT $disconnect it.
	// eslint-disable-next-line sellwild-code/no-server-import-in-client -- dynamic import inside a getServerSideProps-only helper; never reaches the client bundle
	const { default: prisma } = await import('../lib/prisma');

	// First try to find as a subcategory (CATEGORIES table)
	const subcategory = await prisma.categories.findFirst({
		where: {
			slug: category,
			status: 1
		}
	});

	let categoryGroupId = 0;
	let catName = '';
	let isSubcategory = false;

	if (subcategory) {
		// It's a subcategory
		categoryGroupId = subcategory.id;
		catName = subcategory.name;
		isSubcategory = true;
	} else {
		// Try to find as a category group
		const categoryGroups = await prisma.categoryGroups.findMany({
			orderBy: { sortOrder: 'asc' }
		});

		const categoryData = categoryGroups.find(
			cg => dasherize(cg.name) === category
		);

		categoryGroupId = categoryData?.id || 0;
		catName = categoryData?.name || '';
	}

	if (
		typeof process != "undefined" &&
		(process.env.BUILD_FOR_CAPACITOR || process.env.BUILD_FOR_CAPACITOR_STG)
	) {
		return {
			props: {
				mobileTopNav: "left",
				currentList: [],
				interceptBack: true,
				currentCategoryGroupId: null,
				catName: catName,
			},
		};
	}

	let currentList = [];
	if (categoryGroupId) {
		try {
			// Fetch listings using the appropriate parameter
			currentList = await fetchSearchList({
				categoryGroupId: categoryGroupId,
				page: 1,
				status: 1 // Only show active listings
			});
		} catch (error) {
			trackError(asError(error), undefined, { source: 'browse-category-main', action: 'fetchCategoryListings' } as Parameters<typeof trackError>[2]);
			currentList = [];
		}
	}

	return {
		props: {
			mobileTopNav: "left",
			currentList,
			interceptBack: true,
			currentCategoryGroupId: categoryGroupId,
			catName: catName,
			isSubcategory: isSubcategory,
		},
	};
}

export default BrowseCategoryShared;
